import axios from 'axios';
import Vue from 'vue'

class Request {
    constructor(options = {}) {
        const { host = '', contentKey = '', data_code = 1, ...other } = options
        this.options = {
            baseURL:host,
            timeout:3000,
            withCredentials: true,
            ...other
        }
        this.extend_params = { contentKey }
        this.axios = axios.create(this.options)
        this.vue = new Vue()
        this.data_code = data_code
    }
    axiosRequest(method, url, params = {}, call = {}) {
        const method_clonse = method === 'post_upload' ? 'post' : method
        const { final, fail, success } = call
        const {
             contentKey:contentKey_c,
             c_option = {},
             no_need_fail_modal = false,
             no_need_fail_catch_modal = false,
             new_source_params = null,
             ...other
             } = params
        
        const _this = this
        const contentKey = contentKey_c || this.extend_params.contentKey
        let axios_params = method === 'get' ? { params: other } : other
        switch (method) {
            case 'get':
                axios_params = { params: other }
                break;
            case 'post_upload':
                axios_params = params
                break;
            case 'post_download':
                return axios.create({
                    ...this.options,
                    ...c_option,
                    ...(new_source_params || {})
                }).post(url, other)
            default:
                axios_params = other
                break;
        }
        let result = null
        if (new_source_params) { // 重新设置timeout
            result = axios.create({
                ...this.options,
                ...new_source_params,
            })[method_clonse](url, axios_params)
        } else {
            result = this.axios[method_clonse](url, axios_params)
        }
       
        return new Promise((resolve, reject) => {
                result.then((res) => {
                    const data = res.data || {}
                    const { code, msg = '' } = data
                    if (code === this.data_code) {
                        resolve((contentKey === undefined || data[contentKey] === undefined) ? data : data[contentKey])
                        if (success) {
                            success()
                        }
                    } else {
                        if (!no_need_fail_modal) {
                            _this.vue.$vModal.error({
                                title:'错误',
                                content: msg
                            })
                        }
                        if (fail) {
                            fail(res)
                        }
                        reject(msg)
                    }
                }).catch((e) => {
                    if (!no_need_fail_catch_modal) {
                        _this.vue.$vModal.error({
                            title:'错误',
                            content: e.message
                        })
                    }
                    if (fail) {
                        fail()
                    }
                    reject(e)
                }).finally(() => {
                    if (final) {
                        final()
                    }
                })
        })
    }
}


export default Request
